export default __webpack_public_path__ + "static/media/d257ff8049896f3f7fd26063de2221be1599784170072.1fbefda2.webp";